// extracted by mini-css-extract-plugin
module.exports = {"button":"SecondaryButton_button__pUwxr","button_text":"SecondaryButton_button_text__Hvmma","disabled":"SecondaryButton_disabled__QUiLB"};